import { axiosInstance } from "./apiClient";

const TOKEN_KEY = "access_token";

export async function login(
  username: string,
  password: string
): Promise<string> {
  try {
    const response = await axiosInstance.post("/auth/login", {
      username,
      password,
    });
    const token = response.data.access_token;
    localStorage.setItem(TOKEN_KEY, token);
    return token;
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.detail || error.message || "Login failed";
    throw new Error(errorMessage);
  }
}

export function logout(): void {
  localStorage.removeItem(TOKEN_KEY);
}

export function isAuthenticated(): boolean {
  return !!localStorage.getItem(TOKEN_KEY);
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export interface CurrentUser {
  id: string;
  email: string;
  firstname?: string | null;
  lastname?: string | null;
  role?: string;
  is_active: boolean;
  is_verified: boolean;
}

export async function updateCurrentUserProfile(payload: {
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
}): Promise<CurrentUser> {
  const response = await axiosInstance.patch<CurrentUser>("/auth/me", payload);
  return response.data;
}

export async function changeCurrentUserPassword(payload: {
  current_password: string;
  new_password: string;
  new_password_confirm: string;
}): Promise<{ message: string }> {
  const response = await axiosInstance.post<{ message: string }>(
    "/auth/change-password",
    payload
  );
  return response.data;
}
